<!-- 谷歌登录新用户注册成功后,提示邮箱与默认密码 -->
<template>
  <el-dialog
    :visible.sync="innerVisible"
    append-to-body
    custom-class="info-dialog"
    :show-close="false"
    :before-close="beforeCloseFn"
    @close="handleClose"
  >
    <button
      type="button"
      class="info-dialog__close"
      :aria-label="$fanyi('关闭')"
      @click="onCancel"
    >
      <i class="el-icon-close"></i>
    </button>
    <div class="info-dialog__body">
      <div class="info-dialog__logo">
        <img
          :src="require('@/assets/hometop/logo-rakumart-europe.svg')"
          alt="Rakumart"
        />
      </div>
      <h1 class="info-dialog__title">{{ $fanyi("请保存好以下信息") }}</h1>
      <div class="info-dialog-row">
        <div class="info-dialog-row__line">
          <span class="label">{{ $fanyi("邮箱") }}:</span>
          <span class="value">{{ info.email }}</span>
        </div>
        <div class="info-dialog-row__line">
          <span class="label">{{ $fanyi("默认密码") }}:</span>
          <span class="value">{{ info.password }}</span>
        </div>
      </div>
      <p class="tip">
        {{ $fanyi("建议您立即修改默认密码,并且补充个人资料") }}
      </p>
      <div class="info-dialog__footer">
        <el-button type="primary" class="btn-primary" @click="onConfirm">{{
          $fanyi("立即修改")
        }}</el-button>
        <el-button class="btn-cancel" @click="onCancel">{{
          $fanyi("取消")
        }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: "InfoDialog",
  props: {
    beforeClose: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      innerVisible: false,
      info: {
        email: "",
        password: "",
      },
    };
  },
  methods: {
    open(data) {
      this.info = data || { email: "", password: "" };
      this.innerVisible = true;
    },
    onConfirm() {
      this.innerVisible = false;
      this.$fun.routerToPage("/user/userDetail");
    },
    onCancel() {
      this.innerVisible = false;
    },
    beforeCloseFn(done) {
      if (typeof this.beforeClose === "function") {
        this.beforeClose(done);
      } else {
        done();
      }
    },
    handleClose() {
      this.$fun.routerToPage("/");
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/.info-dialog {
  width: 480px;
  border-radius: 16px;
  overflow: hidden;
  background: #ffffff url("~@/assets/login/info-dialog-bg.png") no-repeat center
    top;
  background-size: cover;

  .el-dialog__header {
    display: none;
  }

  .el-dialog__body {
    position: relative;
    padding: 40px;
  }

  .el-dialog__footer {
    display: none;
  }
}

.info-dialog__close {
  position: absolute;
  top: 24px;
  right: 24px;
  z-index: 2;
  width: 16px;
  height: 16px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
  color: #667085;
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: #0c111d;
  }
}

.info-dialog__body {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.info-dialog__logo {
  img {
    display: block;
    width: 160px;
    height: auto;
  }
}

.info-dialog__title {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: #0c111d;
}

.info-dialog-row {
  display: flex;
  flex-direction: column;
  gap: 4px;

  .info-dialog-row__line {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
  }

  .label {
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
    color: #333333;
  }

  .value {
    font-family: "Open Sans", sans-serif;
    font-size: 18px;
    font-weight: 400;
    line-height: 24px;
    color: #f56c6c;
  }
}

.tip {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  color: #333333;
}

.info-dialog__footer {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;

  .el-button {
    margin: 0;
    padding: 10px 20px;
    height: 46px;
    min-width: 120px;
    border-radius: 12px;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
  }

  .btn-primary {
    background: #009246;
    border-color: #009246;
    color: #ffffff;

    &:hover,
    &:focus {
      background: #007a3a;
      border-color: #007a3a;
      color: #ffffff;
    }
  }

  .btn-cancel {
    background: #ffffff;
    border: 1px solid #bddbb8;
    color: #009246;

    &:hover,
    &:focus {
      background: #ffffff;
      border-color: #009246;
      color: #009246;
    }
  }
}
</style>
